import { PagePermissionContext } from '@/shared/permissions/PagePermissionContext';

// Must match SUPPORT_EMAIL in rust-workspace/domain-user-extra-types; the email is all that tells this user apart.
const SUPPORT_EMAIL = 'temporary.support@luminovo.com';

// Internal only, except for the support user, who manages flags on any tenant during support sessions.
export const canAccessFeatureFlagsPage = ({ currentUser }: Pick<PagePermissionContext, 'currentUser'>): boolean => {
    const isSupportUser = currentUser.user.email === SUPPORT_EMAIL;
    return isSupportUser || (currentUser.userType === 'Internal' && currentUser.tenant === 'luminovo');
};
